(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ba-slider-panel"] && !Shopify.designMode) return;
  try {
    class CollectionTabsBaSlider extends HTMLElement {
    connectedCallback() {
      this._initObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this._initObserver.disconnect();
              this._initObserver = null;
              this._init();
            }
          });
        },
        { rootMargin: '200px 0px' }
      );
      this._initObserver.observe(this);
    }

    _init() {
      this.overlay = this.querySelector('.ba-overlay');
      this.overlayImg = this.querySelector('.ba-overlay-img');
      this.bgImg = this.querySelector('.ba-bg-img');
      this.handle = this.querySelector('.ba-handle');
      this.clicked = false;

      if (!this.overlay || !this.handle) return;

      this._onMouseMove = this._onMouseMove.bind(this);
      this._onSlideReady = this._onSlideReady.bind(this);
      this._onSlideFinish = this._onSlideFinish.bind(this);
      this._onResize = this._setImgWidths.bind(this);

      this.addEventListener('mousemove', this._onMouseMove);
      this.addEventListener('touchmove', this._onMouseMove);

      this.handle.addEventListener('mousedown', (e) => { e.preventDefault(); this._onSlideReady(e); });
      this.handle.addEventListener('touchstart', (e) => { e.preventDefault(); this._onSlideReady(e); }, { passive: false });

      window.addEventListener('mouseup', this._onSlideFinish);
      window.addEventListener('touchend', this._onSlideFinish);

      window.addEventListener('resize', this._onResize);

      if (this.bgImg.complete) {
        this._setImgWidths();
      } else {
        this.bgImg.addEventListener('load', () => this._setImgWidths(), { once: true });
      }
    }

    _setImgWidths() {
      if (!this.overlayImg) return;
      const w = this.offsetWidth;
      this.overlayImg.style.width = w + 'px';
      this.bgImg.style.width = w + 'px';

      const half = w / 2;
      this.overlay.style.width = half + 'px';
      this.handle.style.left = (half - 30) + 'px';
    }

    _slide(x) {
      let pos = x - (this.handle.offsetWidth / 2);
      if (window.innerWidth < 768 && pos < -30) pos = -30;
      if (window.innerWidth < 768 && pos > window.innerWidth - 30) pos = window.innerWidth - 30;
      this.overlay.style.width = x + 'px';
      this.handle.style.left = pos + 'px';
    }

    _getCursorPos(e) {
      e = e.changedTouches ? e.changedTouches[0] : e;
      const a = this.overlay.getBoundingClientRect();
      let x = e.pageX - a.left;
      x -= window.pageXOffset;
      return x;
    }

    _onMouseMove(e) {
      if (!this.clicked) return;
      let pos = this._getCursorPos(e);
      if (pos < 0) pos = 0;
      this._slide(pos);
    }

    _onSlideReady(e) {
      e.preventDefault();
      this.clicked = true;
      document.body.classList.add('no-select');
    }

    _onSlideFinish() {
      this.clicked = false;
      document.body.classList.remove('no-select');
    }

    disconnectedCallback() {
      if (this._initObserver) this._initObserver.disconnect();
      window.removeEventListener('mouseup', this._onSlideFinish);
      window.removeEventListener('touchend', this._onSlideFinish);
      window.removeEventListener('resize', this._onResize);
    }
  }

  customElements.define('collection-tabs-ba-slider', CollectionTabsBaSlider);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-payment-banner"] && !Shopify.designMode) return;
  try {
    var waitForShadowroot = (condition, cb) => {
  if (typeof condition === 'function' && typeof cb === 'function') {
    setTimeout(() => {
      if (condition()) { cb(); } else { waitForShadowroot(condition, cb); }
    }, 200);
  }
};
waitForShadowroot(() => document.querySelector('shopify-payment-terms') !== null, () => {
  console.log('found shadowroot');
  document.querySelector('shopify-payment-terms').shadowRoot.append(
    Object.assign(document.createElement('style'), {
      innerText: `span, button, a { font-family: 'SofiaPro', sans-serif !important; }`
    })
  );
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-whats-in-bundle"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-whats-in-bundle]').forEach((wrapper) => {
    const list = wrapper.querySelector('[data-whats-in-bundle-list]');
    const thumb = wrapper.querySelector('[data-whats-in-bundle-thumb]');
    if (!list) return;

    let isDown = false;
    let startX = 0;
    let startScrollLeft = 0;
    let dragDistance = 0;

    const endDrag = () => {
      isDown = false;
      list.classList.remove('is-dragging');
    };

    list.addEventListener('mousedown', (event) => {
      // Without this, the browser starts its own native image-drag
      // operation (images are draggable by default) instead of a plain
      // click-drag, and that swallows the mousemove events below.
      event.preventDefault();
      isDown = true;
      dragDistance = 0;
      startX = event.pageX;
      startScrollLeft = list.scrollLeft;
      list.classList.add('is-dragging');
    });
    window.addEventListener('mouseup', endDrag);
    window.addEventListener('mousemove', (event) => {
      if (!isDown) return;
      event.preventDefault();
      const delta = event.pageX - startX;
      dragDistance = Math.max(dragDistance, Math.abs(delta));
      list.scrollLeft = startScrollLeft - delta * 1.5;
    });

    // The browser still fires a plain `click` on whatever's under the
    // cursor at mouseup, no matter how far the drag travelled in between -
    // without this, releasing a drag over a card silently navigates to it.
    // Only swallow the click once the drag actually moved past a small
    // jitter threshold, so a genuine tap/click still works.
    list.addEventListener('click', (event) => {
      if (dragDistance > 5) {
        event.preventDefault();
        event.stopPropagation();
      }
    });

    if (thumb) {
      const updateThumb = () => {
        const overflow = list.scrollWidth - list.offsetWidth;
        const thumbWidth = Math.min(100, (list.offsetWidth / list.scrollWidth) * 100);
        const progress = overflow > 0 ? list.scrollLeft / overflow : 0;
        thumb.style.width = `${thumbWidth}%`;
        thumb.style.left = `${progress * (100 - thumbWidth)}%`;
      };
      list.addEventListener('scroll', updateThumb);
      window.addEventListener('resize', updateThumb);
      updateThumb();
    }
  });
  } catch(e) { console.error(e); }
})();

})();
